export default "__VITE_ASSET__Dta8xdf2__"